import {
	AbstractControl,
	NG_VALIDATORS,
	Validator,
	ValidationErrors,
} from '@angular/forms';

import { Directive } from '@angular/core';
import { isEmpty } from 'lodash';

import { DATA_VALIDATION } from '../data_validation.constant';

@Directive({
	selector: '[commonEmail]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: CommonEmailValidatorDirective,
		multi: true,
	}],
})
export class CommonEmailValidatorDirective implements Validator {
	validate (control: AbstractControl): ValidationErrors | null {
		let res = null;

		if (!isEmpty(control.value)) {
			res = RegExp(DATA_VALIDATION.email).test(control.value) ? null : {
				email: true,
			};
		}

		return res;
	}
}
